var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymnetMethods01 = function SvgPaymnetMethods01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paymnet_methods-01_svg2__a",
    x1: 5.37,
    x2: 182.49,
    y1: 184.63,
    y2: 7.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__b",
    x1: 70.36,
    x2: 247.47,
    y1: 249.62,
    y2: 72.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__c",
    x1: -54.28,
    x2: 122.84,
    y1: 124.98,
    y2: -52.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__d",
    x1: -45.95,
    x2: 131.17,
    y1: 133.31,
    y2: -43.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__e",
    x1: -37.62,
    x2: 139.5,
    y1: 141.65,
    y2: -35.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__f",
    x1: -20.49,
    x2: 156.63,
    y1: 158.77,
    y2: -18.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__g",
    x1: -12.16,
    x2: 164.96,
    y1: 167.11,
    y2: -10.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__h",
    x1: -3.82,
    x2: 173.3,
    y1: 175.44,
    y2: -1.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__i",
    x1: -29.28,
    x2: 147.83,
    y1: 149.98,
    y2: -27.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#paymnet_methods-01_svg2__a",
    id: "paymnet_methods-01_svg2__j",
    x1: 4.51,
    x2: 181.63,
    y1: 183.77,
    y2: 6.65
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M179.98 103.33h-9.99V3.34c0-1.35-.81-2.56-2.07-3.07a3.325 3.325 0 0 0-3.63.7l-7.63 7.67-7.63-7.67a3.34 3.34 0 0 0-4.37-.3l-11.33 8.5L121.99.69a3.3 3.3 0 0 0-4 0l-11.33 8.5L95.34.69a3.3 3.3 0 0 0-4 0l-11.33 8.5L68.68.69a3.3 3.3 0 0 0-4 0l-11.33 8.5L42.01.69a3.3 3.3 0 0 0-4 0l-11.33 8.5L15.35.69a3.33 3.33 0 0 0-3.5-.3 3.26 3.26 0 0 0-1.83 2.97v193.3c-.01 1.26.7 2.42 1.83 2.97 1.13.57 2.48.46 3.5-.3l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.33 1 3.19.88 4.37-.3l7.63-7.67 7.63 7.67c.63.62 1.48.97 2.37.97.44.01.87-.08 1.27-.27 1.25-.5 2.07-1.72 2.07-3.07v-23.33h10a10.03 10.03 0 0 0 10-10v-49.99a10.03 10.03 0 0 0-10-10Zm0 6.67c1.84 0 3.33 1.49 3.33 3.33v3.33H90v-3.33c0-1.84 1.49-3.33 3.33-3.33zm3.34 13.33v3.33H90v-3.33zm-20 65.29-4.3-4.33a3.356 3.356 0 0 0-4.73 0l-7.93 7.97-11.03-8.27a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-11.33 8.5-11.33-8.5a3.3 3.3 0 0 0-4 0l-8 6V10.01l8 6c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0l11.33-8.5 11.33 8.5c1.18.9 2.82.9 4 0L120 7.51l11.33 8.5c1.18.9 2.82.9 4 0l11.03-8.27 7.93 7.97c1.31 1.3 3.42 1.3 4.73 0l4.3-4.33v91.95H93.34a10.03 10.03 0 0 0-10 10v49.99a10.03 10.03 0 0 0 10 10h69.98v15.29Zm20.01-25.3c0 1.84-1.49 3.33-3.33 3.33H93.35c-1.84 0-3.33-1.49-3.33-3.33v-30h93.32v30Z",
    style: {
      fill: "url(#paymnet_methods-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.32 163.32h13.33a8.33 8.33 0 0 0 0-16.66h-13.33a8.33 8.33 0 0 0 0 16.66m0-10h13.33c.92 0 1.67.75 1.67 1.67s-.75 1.67-1.67 1.67h-13.33c-.92 0-1.67-.75-1.67-1.67s.75-1.67 1.67-1.67",
    style: {
      fill: "url(#paymnet_methods-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.04 30.01H31.68c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.04 46.67H31.68c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.04 63.34H31.68c-1.84 0-3.33 1.49-3.33 3.33S29.84 70 31.68 70h11.36c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22 36.67h83.44c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.22c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22 53.34h83.44c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.22c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.22 70.01h83.44c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H63.22c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#paymnet_methods-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.02,
    height: 6.67,
    x: 28.35,
    y: 80,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#paymnet_methods-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 90.11,
    height: 6.67,
    x: 59.89,
    y: 80,
    rx: 3.33,
    ry: 3.33,
    style: {
      fill: "url(#paymnet_methods-01_svg2__j)"
    }
  }));
};
export default SvgPaymnetMethods01;